var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 607,
    viewBox: "0 0 611 607",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M519.701 351.356C519.701 416.169 495.243 459.466 456.218 486.69C417.015 514.037 362.744 525.415 302.794 525.415C242.847 525.415 185.549 514.038 143.333 486.634C101.298 459.347 73.9775 416.031 73.9775 351.356C73.9776 286.086 89.7088 215.224 120.294 160.785C150.879 106.347 195.995 68.8039 254.753 68.8039C313.841 68.8041 380.094 106.712 431.732 161.376C483.344 216.011 519.701 286.699 519.701 351.356Z",
    fill: "#E5EBFF",
    stroke: "#CACED7",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.554 141.482C514.129 172.991 538.648 214.703 542.53 260.912C546.429 307.338 529.531 358.743 500.27 409.424C471.011 460.102 433.465 503.002 389.788 525.357C346.304 547.613 296.51 549.643 242.054 518.203C187.081 486.464 135.077 438.709 104.155 386.388C73.235 334.069 63.6377 277.694 92.3041 228.042C121.135 178.105 185.39 140.535 256.634 123.466C327.843 106.405 405.113 110.051 459.554 141.482Z",
    fill: "#CEDAFF",
    stroke: "#CACED7",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4682_2785)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 130,
    width: 386,
    height: 359,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 132,
    width: 382,
    height: 355,
    rx: 18,
    stroke: "#CACED7",
    strokeWidth: 4
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.312 315.312C312.312 318.247 309.934 320.625 307 320.625C304.066 320.625 301.688 318.247 301.688 315.312C301.688 312.378 304.066 310 307 310C309.934 310 312.312 312.378 312.312 315.312Z",
    fill: "#CACED7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.125 336.562C278.059 336.562 280.438 334.184 280.438 331.25C280.438 328.316 278.059 325.938 275.125 325.938C272.191 325.938 269.812 328.316 269.812 331.25C269.812 334.184 272.191 336.562 275.125 336.562Z",
    fill: "#CACED7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.438 347.188C280.438 350.122 278.059 352.5 275.125 352.5C272.191 352.5 269.812 350.122 269.812 347.188C269.812 344.253 272.191 341.875 275.125 341.875C278.059 341.875 280.438 344.253 280.438 347.188Z",
    fill: "#CACED7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.062 336.562C293.997 336.562 296.375 334.184 296.375 331.25C296.375 328.316 293.997 325.938 291.062 325.938C288.128 325.938 285.75 328.316 285.75 331.25C285.75 334.184 288.128 336.562 291.062 336.562Z",
    fill: "#CACED7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.375 347.188C296.375 350.122 293.997 352.5 291.062 352.5C288.128 352.5 285.75 350.122 285.75 347.188C285.75 344.253 288.128 341.875 291.062 341.875C293.997 341.875 296.375 344.253 296.375 347.188Z",
    fill: "#CACED7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307 336.562C309.934 336.562 312.312 334.184 312.312 331.25C312.312 328.316 309.934 325.938 307 325.938C304.066 325.938 301.688 328.316 301.688 331.25C301.688 334.184 304.066 336.562 307 336.562Z",
    fill: "#CACED7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312.312 347.188C312.312 350.122 309.934 352.5 307 352.5C304.066 352.5 301.688 350.122 301.688 347.188C301.688 344.253 304.066 341.875 307 341.875C309.934 341.875 312.312 344.253 312.312 347.188Z",
    fill: "#CACED7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M322.938 336.562C325.872 336.562 328.25 334.184 328.25 331.25C328.25 328.316 325.872 325.938 322.938 325.938C320.003 325.938 317.625 328.316 317.625 331.25C317.625 334.184 320.003 336.562 322.938 336.562Z",
    fill: "#CACED7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M328.25 347.188C328.25 350.122 325.872 352.5 322.938 352.5C320.003 352.5 317.625 350.122 317.625 347.188C317.625 344.253 320.003 341.875 322.938 341.875C325.872 341.875 328.25 344.253 328.25 347.188Z",
    fill: "#CACED7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M338.875 336.562C341.809 336.562 344.188 334.184 344.188 331.25C344.188 328.316 341.809 325.938 338.875 325.938C335.941 325.938 333.562 328.316 333.562 331.25C333.562 334.184 335.941 336.562 338.875 336.562Z",
    fill: "#CACED7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M328.25 315.312C328.25 318.247 325.872 320.625 322.938 320.625C320.003 320.625 317.625 318.247 317.625 315.312C317.625 312.378 320.003 310 322.938 310C325.872 310 328.25 312.378 328.25 315.312Z",
    fill: "#CACED7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M338.875 320.625C341.809 320.625 344.188 318.247 344.188 315.312C344.188 312.378 341.809 310 338.875 310C335.941 310 333.562 312.378 333.562 315.312C333.562 318.247 335.941 320.625 338.875 320.625Z",
    fill: "#CACED7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.812 240.938C272.747 240.938 275.125 243.316 275.125 246.25V256.875H338.875V246.25C338.875 243.316 341.253 240.938 344.188 240.938C347.122 240.938 349.5 243.316 349.5 246.25V256.875H354.812C366.549 256.875 376.062 266.389 376.062 278.125V357.812C376.062 369.549 366.549 379.062 354.812 379.062H259.188C247.451 379.062 237.938 369.549 237.938 357.812V278.125C237.938 266.389 247.451 256.875 259.188 256.875H264.5V246.25C264.5 243.316 266.878 240.938 269.812 240.938ZM365.438 304.688C365.438 298.819 360.681 294.062 354.812 294.062H259.188C253.319 294.062 248.562 298.819 248.562 304.688V357.812C248.562 363.681 253.319 368.438 259.188 368.438H354.812C360.681 368.438 365.438 363.681 365.438 357.812V304.688Z",
    fill: "#CACED7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4682_2785",
    x: 100,
    y: 118,
    width: 414,
    height: 387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4682_2785"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.692708 0 0 0 0 0.713914 0 0 0 0 0.791667 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4682_2785"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4682_2785",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalendar);
export default __webpack_public_path__ + "static/media/empty-calendar.3b20c58939bf7b37d7474ad5cf8f8bc7.svg";
export { ForwardRef as ReactComponent };